import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HID } from "@/constants/cosecIds";

const FAQS = [
  {
    q: "What is company secretarial software?",
    a: "Company secretarial software helps businesses manage statutory records, governance tasks, Companies House obligations, shareholder information, and compliance deadlines from one secure platform.",
  },
  {
    q: "What should businesses look for in company secretarial software in the UK?",
    a: "Look for software that helps manage statutory registers, Companies House deadlines, shareholder and director records, governance workflows, audit trails, secure access, and multi-entity visibility. The best solutions save time, reduce compliance risk, and make records easier to manage. CoSec is designed for UK businesses that need better control, visibility, and efficiency.",
  },
  {
    q: "What does CoSec help businesses manage?",
    a: "CoSec helps businesses manage company secretarial work, statutory records, directors, shareholders, ownership changes, governance activity, and filing deadlines in one place.",
  },
  {
    q: "Can CoSec help with Companies House filing deadlines?",
    a: "Yes. CoSec helps teams track important Companies House deadlines, organise records, and reduce the risk of missed filings or last-minute issues.",
  },
  {
    q: "Can CoSec replace spreadsheets and shared folders?",
    a: "Yes. CoSec replaces spreadsheets, email chains, and scattered folders with one secure system built for managing company records and compliance activity.",
  },
  {
    q: "What is entity management software?",
    a: "Entity management software helps businesses manage multiple legal entities, ownership structures, statutory data, governance actions, and compliance records from one platform.",
  },
  {
    q: "Is CoSec suitable for businesses with multiple entities?",
    a: "Yes. CoSec is ideal for businesses managing more than one entity, helping maintain visibility across structures, records, deadlines, and responsibilities.",
  },
  {
    q: "How does CoSec improve corporate governance?",
    a: "CoSec improves governance by centralising records, documenting decisions, tracking actions, and giving leadership clearer oversight of obligations.",
  },
  {
    q: "Is CoSec secure for sensitive company data?",
    a: "Yes. CoSec uses modern security measures, controlled access, and secure cloud infrastructure to protect sensitive company information.",
  },
  {
    q: "Can small businesses use company secretarial software?",
    a: "Yes. Small and growing businesses use CoSec to stay organised, reduce compliance risk, and build strong governance foundations early.",
  },
  {
    q: "What records should UK companies keep?",
    a: "UK companies typically maintain statutory registers, director details, shareholder records, resolutions, filing history, and ownership changes.",
  },
  {
    q: "How can I see CoSec in action?",
    a: "You can book a personalised demo to see how CoSec helps businesses manage records, governance, and compliance more efficiently.",
  },
];

export default function FAQ() {
  return (
    <section id="faqs" className="py-20 md:py-28">
      <div className="container-cv">
        <div className="max-w-3xl mx-auto text-center">
          <span className="section-eyebrow">FAQs</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.08]">
            Frequently Asked Questions About CoSec
          </h2>
          <p className="mt-4 text-base md:text-lg text-muted-foreground">
            Popular questions about company secretarial software and compliance.
          </p>
        </div>

        <div className="mt-12 max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={HID.faqItem(i + 1)}
                className="rounded-xl border border-border bg-white px-5 data-[state=open]:shadow-sm"
              >
                <AccordionTrigger className="text-left font-display font-bold text-primary hover:no-underline py-5">
                  <span className="flex items-baseline gap-3">
                    <span className="font-mono text-xs font-bold text-accent">{String(i + 1).padStart(2, "0")}</span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-muted-foreground leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
